module.exports = __webpack_public_path__ + "static/media/dropdown.373c4645.svg";